import { defineComponent as m, ref as a, onMounted as d, watch as r, createElementBlock as f, openBlock as y, mergeProps as g, withDirectives as v, renderSlot as p, createElementVNode as C, vShow as T } from "vue";
import { t as h } from "./tippy.esm-DLHdsnfG.js";
const k = /* @__PURE__ */ m({
  __name: "Tooltip",
  props: {
    content: {
      type: String,
      default: ""
    },
    placement: {
      type: String,
      default: "top"
    },
    trigger: {
      type: String,
      default: "mouseenter focus"
    },
    // show delay is 100ms, hide delay is the default
    delay: {
      type: [Number, Array],
      default: () => 0
    },
    hideOnClick: {
      type: Boolean,
      default: !0
    },
    isUseCustomTemplate: {
      type: Boolean,
      default: !1
    },
    theme: {
      type: String,
      default: "arbo",
      required: !1
    }
  },
  setup(u) {
    const e = u, s = a(null), l = a(null), t = a(null);
    d(() => {
      c(), !e.content && t && t.value?.disable();
    });
    const c = () => {
      t.value = h(s.value, {
        //@ts-ignore
        content: () => e.isUseCustomTemplate && l.value?.innerHTML ? l.value : e.content,
        placement: e.placement,
        trigger: e.trigger,
        hideOnClick: e.hideOnClick,
        //@ts-ignore
        delay: e.delay,
        theme: e.theme || "arbo",
        arrow: !0,
        allowHTML: !0,
        appendTo: () => document.body,
        zIndex: 9999
      });
    };
    return r([() => e.content, () => e.isUseCustomTemplate], ([o, n]) => {
      const i = n && l.value?.innerHTML ? l.value : o;
      i ? (t.value?.setContent(i), t.value?.enable()) : t.value?.disable();
    }), r(
      () => e.delay,
      (o) => {
        const n = t.value?.props;
        t.value?.setProps({
          ...n,
          delay: o
        });
      },
      { immediate: !0 }
    ), r([() => e.placement, () => e.trigger], ([o, n]) => {
      t.value?.setProps({
        placement: o,
        trigger: n
      });
    }), (o, n) => (y(), f("div", g({
      class: "tooltip",
      ref_key: "tooltipTarget",
      ref: s
    }, o.$attrs), [
      v(C("div", {
        class: "tooltip__content",
        ref_key: "tooltipContent",
        ref: l
      }, [
        p(o.$slots, "content")
      ], 512), [
        [T, e.isUseCustomTemplate]
      ]),
      p(o.$slots, "default")
    ], 16));
  }
});
export {
  k as _
};
